module.exports = __webpack_public_path__ + "static/Logo_Kreis_GG_ohne_Hintergrund-97a01591b1bba92e8664a3a8fc184200.jpg";